const Index = () => import(/* webpackChunkName: "index" */ '@/pages/index.vue')
const Callback = () =>
  import(/* webpackChunkName: "callback" */ '@/pages/callback.vue')
const Error = () => import(/* webpackChunkName: "error" */ '@/pages/error.vue')
const ForgotPassword = () =>
  import(/* webpackChunkName: "forgot-password" */ '@/pages/forgot-password.vue')
const Logout = () =>
  import(/* webpackChunkName: "logout" */ '@/pages/logout.vue')
const ResetPassword = () =>
  import(/* webpackChunkName: "reset-password" */ '@/pages/reset-password.vue')
const SignIn = () =>
  import(/* webpackChunkName: "sign-in" */ '@/pages/sign-in.vue')
const UnblockUser = () =>
  import(/* webpackChunkName: "unblock-user" */ '@/pages/unblock-user.vue')
const ValidateMfa = () =>
  import(/* webpackChunkName: "validate-mfa" */ '@/pages/validate-mfa.vue')
const LangIndex = () =>
  import(/* webpackChunkName: "lang-index" */ '@/pages/_lang/index.vue')
const LangForgotPassword = () =>
  import(/* webpackChunkName: "lang-forgot-password" */ '@/pages/_lang/forgot-password.vue')
const LangResetPassword = () =>
  import(/* webpackChunkName: "lang-reset-password" */ '@/pages/_lang/reset-password.vue')
const LangSignIn = () =>
  import(/* webpackChunkName: "lang-sign-in" */ '@/pages/_lang/sign-in.vue')
const LangUnblockUser = () =>
  import(/* webpackChunkName: "lang-unblock-user" */ '@/pages/_lang/unblock-user.vue')
const LangValidateMfa = () =>
  import(/* webpackChunkName: "lang-validate-mfa" */ '@/pages/_lang/validate-mfa.vue')

export default [
  {
    name: 'index',
    path: '',
    component: Index
  },
  {
    name: 'callback',
    path: 'callback',
    component: Callback,
    meta: {
      isOidcCallback: true
    }
  },
  {
    name: 'error',
    path: 'error',
    component: Error,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'forgot-password',
    path: 'forgot-password',
    component: ForgotPassword,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'logout',
    path: 'logout',
    component: Logout
  },
  {
    name: 'reset-password',
    path: 'reset-password',
    component: ResetPassword,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'sign-in',
    path: 'sign-in',
    component: SignIn,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'unblock-user',
    path: 'unblock-user',
    component: UnblockUser,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'validate-mfa',
    path: 'validate-mfa',
    component: ValidateMfa,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'lang-index',
    path: ':lang',
    component: LangIndex
  },
  {
    name: 'lang-forgot-password',
    path: ':lang/forgot-password',
    component: LangForgotPassword,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'lang-reset-password',
    path: ':lang/reset-password',
    component: LangResetPassword,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'lang-sign-in',
    path: ':lang/sign-in',
    component: LangSignIn,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'lang-unblock-user',
    path: ':lang/unblock-user',
    component: LangUnblockUser,
    meta: {
      isPublic: true
    }
  },
  {
    name: 'lang-validate-mfa',
    path: ':lang/validate-mfa',
    component: LangValidateMfa,
    meta: {
      isPublic: true
    }
  }
]
